import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import "./Styles/Login.css";

const Signup = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        university: "",
        team: [],
        fitReason: "",
        comments: "",
        password: ""
    });

    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (type === "checkbox") {
            setFormData((prevData) => ({
                ...prevData,
                team: checked
                    ? [...prevData.team, value]
                    : prevData.team.filter((team) => team !== value),
            }));
        } else {
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch("https://dalhousiecombatroboticsteam.onrender.com/signup", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            const data = await response.json();
            alert(data.message);
            setFormData({
                name: "",
                email: "",
                university: "",
                team: [],
                fitReason: "",
                comments: "",
                password: ""
            });
            navigate("/login");
        } catch (error) {
            console.error("Signup error:", error);
            alert("An error occurred during signup.");
        }
    };

    return (
        <div className="login-container">
            <h2>Sign Up</h2>
            <form onSubmit={handleSubmit}>
                <label>Name:</label>
                <input type="text" name="name" value={formData.name} onChange={handleChange} required />

                <label>Email (University email preferred):</label>
                <input type="email" name="email" value={formData.email} onChange={handleChange} required />

                <label>What university do you attend?</label>
                <input type="text" name="university" value={formData.university} onChange={handleChange} required />

                <label>What team are you looking forward to joining?</label>
                <div className="checkbox-group">
                    {["Electrical", "Mechanical", "Software", "Management"].map((team) => (
                        <label key={team}>
                            <input
                                type="checkbox"
                                name="team"
                                value={team}
                                checked={formData.team.includes(team)}
                                onChange={handleChange}
                            />{" "}
                            {team}
                        </label>
                    ))}
                </div>

                <label>Why do you think you are a good fit for the Dalhousie Combat Robotics Team?</label>
                <textarea
                    name="fitReason"
                    value={formData.fitReason}
                    onChange={handleChange}
                    rows="4"
                    required
                ></textarea>

                <label>Any additional comments:</label>
                <textarea
                    name="comments"
                    value={formData.comments}
                    onChange={handleChange}
                    rows="3"
                ></textarea>

                <label>Password:</label>
                <input type="password" name="password" value={formData.password} onChange={handleChange} required />

                <button type="submit">Sign Up</button>
            </form>
            <p className="signup-link">
                Already have an account? <Link to="/login">Login here</Link>
            </p>
        </div>
    );
};

export default Signup;
